/** A product type and the user responsible for it. */
export class ProductTypeResponsible {
  productType: string = "";
  responsible: string = "";
}

/**
 * Single document holding the responsible of every product type.
 * Stored in the customer's config database.
 */
export class ProductTypeResponsibles {
  _id?: string;
  _rev?: string;
  type?: string = "productTypeResponsibles";
  responsibles: ProductTypeResponsible[] = [];
}

/** One row of the excel import - the product type is imported as designType. */
export class ProductTypeResponsibleRow {
  [key: string]: any;
  designType: string = "";
  responsible: string = "";
}
